<template>
     <el-tooltip class="item"
                 effect="dark"
                 content="Test Integration Connection"
                 placement="top">
            <div slot="content">
                <strong>Test Connection</strong>
                <br>
                <small>This will check if your connection to {{ integrationNameWithCasing }} still works.</small>
            </div>
            <el-button size="mini" @click="testConnection" :loading="isLoading">
                {{ isLoading ? 'Checking...' : 'Test Connection' }}
            </el-button>
    </el-tooltip>
</template>
<script>
import { ConnectionStatus } from '../../utils/integration-helpers'
import {GOHIGHLEVEL_INTEGRATION, HUBSPOT_CALLING_INTEGRATION, HUBSPOT_INTEGRATION, SALESFORCE_INTEGRATION} from "../../constants/integrations";

export default {
    props: {
        integrationName: {
            type: String,
            required: true,
            validator: (value) => [HUBSPOT_INTEGRATION, HUBSPOT_CALLING_INTEGRATION, SALESFORCE_INTEGRATION, GOHIGHLEVEL_INTEGRATION].includes(value)
        },
        integrationNameWithCasing: {
            type: String,
            required: true,
        },
        connectionStatus: {
            type: Number,
            required: true,
            validator: (value) => [ConnectionStatus.UNKNOWN, ConnectionStatus.CONNECTED, ConnectionStatus.FAILED].includes(value)
        }
    },
    data() {
        return {
            isLoading: false,
        }
    },
    methods: {
        async testConnection() {
            this.isLoading = true

            try {
                await axios.get(`/api/v1/integration/${this.integrationName}/status`)
                this.$emit('on-success', true)
            } catch (error) {
                this.$emit('on-success', false)
            }

            this.isLoading = false
        }
    },
    async mounted() {
        if (this.connectionStatus !== ConnectionStatus.UNKNOWN) return
        await this.testConnection()
    }
}
</script>
